// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 132) return "static/chunks/a5d1118a-4e18abbf46a2cd60.js";
	if (chunkId === 928) return "static/chunks/928-cfb26cbe54bc907c.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"146":"datadog_browser_logs","340":"layout__client_site_chrome_ui","367":"layout__minimal","748":"datadog_browser_rum"}[chunkId] || chunkId) + "." + {"146":"431ec11b0341bd48","205":"2e90144ef4045da8","319":"0cbc2894a3f1b950","340":"0e7901390198044b","367":"1fbac408dc3e8dea","639":"e7b660adfa99260e","748":"2f25c4f96e33dec2"}[chunkId] + ".js";
};